import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { EventHelperTypes } from '../services/exports/Constants';
import HelperMethods from '../services/exports/HelperMethods';
import { useAuth } from './AuthProvider';

export default function SideEffectsProvider({ children }) {
  const { event } = useSelector((state) => state.eventHelper);

  const { logOut } = useAuth();

  useEffect(() => {
    handleReduxSideEffects();
  }, [event]);

  async function handleReduxSideEffects() {
    try {
      const { type } = event;

      if (!type) {
        return;
      }

      return new Promise((resolve) => {
        switch (type) {
          case EventHelperTypes.LogOut:
            logOut();
            break;
        }

        resolve(true);
      }).then(HelperMethods.resetEventSideEffects);
    } catch (error) {
      console.error(`Failed to handle redux side effect: ${error}`);
    }
  }

  return <>{children}</>;
}
